import React from 'react';
import './Yhteystiedot.css';
import { FaEnvelope, FaPhone, FaBuilding, FaInfoCircle, FaMapMarkerAlt } from 'react-icons/fa';

const Yhteystiedot = () => {
  return (
    <div className="yhteystiedot-container">
      <div className="contact-cards-wrapper">
        <div className="contact-card">
          <h3>Yhteystiedot</h3>
          <p className="contact-item">
            <FaEnvelope className="contact-icon" />
            <a href="mailto:perttumutka@gmail.com">perttumutka@gmail.com</a>
          </p>
          <p className="contact-item">
            <FaPhone className="contact-icon" />
            <span>+358 50 415 5066</span>
          </p>
        </div>
        <div className="contact-card">
          <h3>Laskutustiedot</h3>
          <p className="contact-item"><FaBuilding className="contact-icon" /> <span>Remena Osk</span></p>
          <p className="contact-item"><FaInfoCircle className="contact-icon" /> <span>Y-tunnus: 2725105-3</span></p>
          <p className="contact-item"><FaMapMarkerAlt className="contact-icon" /> <span>Jääkärinkatu 8, 80220 Joensuu</span></p>
        </div>
      </div>
    </div>
  );
};

export default Yhteystiedot;